import type { MandateStatus } from "@/types/mandate";

export interface MandateTabDef {
  key: string;
  label: string;
  status: MandateStatus | null;
}

export const MANDATE_TAB_DEFS: MandateTabDef[] = [
  { key: "All", label: "All", status: null },
  { key: "Draft", label: "Draft", status: "DRAFT" },
  { key: "Active", label: "Active", status: "ACTIVE" },
  { key: "Created", label: "Created", status: "CREATED" },
  { key: "Completed", label: "Completed", status: "COMPLETED" },
  { key: "Terminated", label: "Terminated", status: "TERMINATED" },
  { key: "Cancelled", label: "Cancelled", status: "CANCELLED" },
  { key: "Paused", label: "Paused", status: "PAUSED" },
  { key: "Halted", label: "Halted", status: "HALTED" },
];


// Real auth-mode values as produced by the backend (see mandates-controller.js).
export const AUTH_MODE_OPTIONS: { value: string; label: string }[] = [
  { value: "eNACH", label: "eNACH" },
  { value: "UPI Autopay", label: "UPI Autopay" },
];

export const MANDATE_SORT_OPTIONS: { value: string; label: string }[] = [
  { value: "Newest First", label: "Newest First" },
  { value: "Oldest First", label: "Oldest First" },
  { value: "Highest Amount", label: "Highest Amount" },
  { value: "Lowest Amount", label: "Lowest Amount" },
];
